import React, { useState, useEffect } from "react";
import { ordersData } from "../../Datas/OrdersData";
import './RecentOrdersTable.css';
import OrderTrackingModal from '../OrderTrackingModal/OrderTrackingModal';

const RecentOrdersTable = () => {
  const [modalData, setModalData] = useState(null);
  const [isTrackingModalOpen, setIsTrackingModalOpen] = useState(false); // State to handle opening of tracking modal
  const [currentOrder, setCurrentOrder] = useState(null); // State to store the current order data for tracking modal

  const sortOrdersByDate = () => {
    return ordersData.sort((a, b) => {
      const dateA = new Date(a.bookingDate);
      const dateB = new Date(b.bookingDate);
      return dateB - dateA; 
    });
  };

  const getRecentOrders = () => {
    const sortedOrders = sortOrdersByDate();
    return sortedOrders.slice(0, 5); 
  };

  const openInvoiceModal = (invoiceUrl) => {
    setModalData(invoiceUrl);
  };

  const openTrackingModal = (order) => {
    setCurrentOrder(order); 
    setIsTrackingModalOpen(true); 
  };

  const closeModal = () => {
    setModalData(null);
    setIsTrackingModalOpen(false); 
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Delivered":
        return "status-delivered";
      case "Packaging":
        return "status-packaging";
      case "Shipped":
        return "status-shipped";
      case "Out for Delivery":
        return "status-out-for-delivery";
      default:
        return "";
    }
  };

  useEffect(() => {
    setModalData(null);
    setIsTrackingModalOpen(false); 
  }, []);

  return (
    <div className="recent-orders-container">
      <h1 className="recent">Recent Orders</h1>

      <table className="orders-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Vendor</th> 
            <th>Booking Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {getRecentOrders().map((order) => (
            <tr key={order.id}>
              <td>{order.name}</td>
              <td>{order.vendorName}</td>
              <td>{order.bookingDate}</td>
              <td className={getStatusClass(order.status)}>{order.status}</td>
              <td>
                <button
                  className="details-button"
                  onClick={() => openInvoiceModal(order.invoice)}
                >
                  Details
                </button>

                <button
                  className="Track-button"
                  onClick={() => openTrackingModal(order)} 
                >
                  Track
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalData && (
        <div className="modal-overlay">
          <div className="modal-content-invoice">
            <button className="close-button" onClick={closeModal}>
              &times;
            </button>
            <h3>Invoice</h3>
            <img src={modalData} alt="Invoice" />
          </div>
        </div>
      )}

      {/* Display the tracking modal if it is open */}
      {isTrackingModalOpen && currentOrder && (
        <OrderTrackingModal
          order={currentOrder}  // Pass the current order data to the modal
          onClose={closeModal}  // Close the modal on button click
        />
      )}
    </div>
  );
};

export default RecentOrdersTable;
